export default __webpack_public_path__ + "static/media/g2021-4.842daf5f.jpeg";